import * as Types from '../../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type GetEnrichedSavedPropertyIdsQueryVariables = Types.Exact<{
    [key: string]: never;
}>;

export type GetEnrichedSavedPropertyIdsQuery = { __typename?: 'Query' } & {
    enrichedSavedPropertyIds:
        | ({ __typename?: 'EnrichedSavedPropertyIdsSuccess' } & {
              enrichedSavedPropertyIds?: Types.Maybe<
                  Array<
                      { __typename?: 'EnrichedSavedPropertyId' } & Pick<
                          Types.EnrichedSavedPropertyId,
                          | 'category'
                          | 'listingId'
                          | 'publicationStatus'
                          | 'savedDate'
                          | 'section'
                      >
                  >
              >;
          })
        | ({ __typename?: 'EnrichedSavedPropertyIdsFail' } & Pick<
              Types.EnrichedSavedPropertyIdsFail,
              'errorCode'
          >);
};

export const GetEnrichedSavedPropertyIdsDocument = gql`
    query getEnrichedSavedPropertyIds {
        enrichedSavedPropertyIds {
            ... on EnrichedSavedPropertyIdsSuccess {
                enrichedSavedPropertyIds {
                    category
                    listingId
                    publicationStatus
                    savedDate
                    section
                }
            }
            ... on EnrichedSavedPropertyIdsFail {
                errorCode
            }
        }
    }
`;

/**
 * __useGetEnrichedSavedPropertyIdsQuery__
 *
 * To run a query within a React component, call `useGetEnrichedSavedPropertyIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrichedSavedPropertyIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrichedSavedPropertyIdsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnrichedSavedPropertyIdsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetEnrichedSavedPropertyIdsQuery,
        GetEnrichedSavedPropertyIdsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetEnrichedSavedPropertyIdsQuery,
        GetEnrichedSavedPropertyIdsQueryVariables
    >(GetEnrichedSavedPropertyIdsDocument, options);
}
export function useGetEnrichedSavedPropertyIdsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetEnrichedSavedPropertyIdsQuery,
        GetEnrichedSavedPropertyIdsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetEnrichedSavedPropertyIdsQuery,
        GetEnrichedSavedPropertyIdsQueryVariables
    >(GetEnrichedSavedPropertyIdsDocument, options);
}
export type GetEnrichedSavedPropertyIdsQueryHookResult = ReturnType<
    typeof useGetEnrichedSavedPropertyIdsQuery
>;
export type GetEnrichedSavedPropertyIdsLazyQueryHookResult = ReturnType<
    typeof useGetEnrichedSavedPropertyIdsLazyQuery
>;
export type GetEnrichedSavedPropertyIdsQueryResult = Apollo.QueryResult<
    GetEnrichedSavedPropertyIdsQuery,
    GetEnrichedSavedPropertyIdsQueryVariables
>;
